var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fa"},[_c('img',{attrs:{"src":require("../assets/pic/error1.png"),"alt":""}}),(_vm.error)?_c('p',{staticClass:"error-title"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }